import { Component, OnInit } from '@angular/core';

import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {AppService} from "../../app.service";

@Component({
    selector: 'app-publish-button',
    imports: [RouterLink, TranslateModule],
    templateUrl: './publish-button.component.html',
    styleUrls: ['./publish-button.component.scss']
})
export class PublishButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  protected readonly AppService = AppService;
}
